export interface ICoachBest{
    teamId: number,
    teamName: string,
    formationName: string,
    seasonName: string,
    stylisticFit: number | null,
    coachId: number,
    coachName: string
}
export interface IArchetypeByCoach {
    archetypeId:number,
    archetypeName: string,
    formationName: string,
    ppg: number,
    usagePercentage: number,
    coachId: number,
    coachName: string,
    competitionId: number,
    seasonId: number,
    seasonName: string,
    coachsBest: ICoachBest,
    archetypesBest: ICoachBest,
    formationId : number
}

export interface ICoachBySeasonData {
    archetypes : IArchetypeByCoach[]
}

export interface ITeamArchetyprRawPscoreBeforeAfter{
    [key: string]: number | null;
    accelerations: number | null,
    aerialDuels: number | null,
    pressing: number | null,
    crosses: number | null,
    defensiveDuels: number | null,
    dribbles: number | null,
    interceptions: number | null,
    forwardPasses: number | null,
    fouls: number | null,
    headShots: number | null,
    linkupPlays: number | null,
    offensiveDuels: number | null,
    passes: number | null,
    passLength: number | null,
    passesToFinaleThird: number | null,
    passingRate: number | null,
    shots: number | null,
    throughPasses: number | null,
    touchInBox: number | null,
    xgShot: number | null,
    xgShotAgainst: number | null,
    dangerousOpponentHalfRecoveries: number | null
}

export interface ISimulationSimiliarity{
    before: number,
    after: number,
    improvement: number,
    relativeImprovement: number
}

export interface ISimulation{
    targetedTeam: string,
    targetedTeamSeason: string,
    targetedTeamFormation: string,
    similarity: ISimulationSimiliarity,
    teamArchetypeRawBefore:ITeamArchetyprRawPscoreBeforeAfter,
    teamArchetypeRawAfter: ITeamArchetyprRawPscoreBeforeAfter,
    teamArchetypePscoreBefore: ITeamArchetyprRawPscoreBeforeAfter,
    teamArchetypePscoreAfter:ITeamArchetyprRawPscoreBeforeAfter,
    // footprintRow:ITeamArchetyprRawPscoreBeforeAfter,
    // footprintPscore:ITeamArchetyprRawPscoreBeforeAfter,
    targetedTeamRaw:ITeamArchetyprRawPscoreBeforeAfter,
    targetedTeamPscore:ITeamArchetyprRawPscoreBeforeAfter
}

export interface ISimulationSubAttributes{
  score: number,
  star: boolean
}

export interface ISimulationAttributesOldNew{
   finalThird: {
      avgScore: number,
      finishingShots: ISimulationSubAttributes,
      finishingAerial: ISimulationSubAttributes,
      attackPositioning: ISimulationSubAttributes
  },
  buildUpPlay: {
      avgScore: number,
      creativity: ISimulationSubAttributes,
      passingAccuracy: ISimulationSubAttributes,
      dribbling: ISimulationSubAttributes,
      crossing: ISimulationSubAttributes
  },
  defence: {
      avgScore: number,
      tackling: ISimulationSubAttributes,
      defensiveHeaders: ISimulationSubAttributes,
      aggression: ISimulationSubAttributes
  }
}

export interface ISimulationAttributesData {
    teamAttributesOld: ISimulationAttributesOldNew,
    teamAttributesNew: ISimulationAttributesOldNew
}

export interface ITeamFinancialSimulationData{
    beforValue: {
        totalWages: number,
        totalWagesText: string,
        avgWage: number,
        avgWageText: string,
        squadValue: number,
        squadValueText: string,
        avgAgeValue: number
    },
    afterValue: {
        totalWages: number,
        totalWagesText: string,
        avgWage: number,
        avgWageText: string,
        squadValue: number,
        squadValueText: string,
        avgAgeValue: number
    }
}

export const getBackgroundColor = (performanceValue: number | "") => {
  if (performanceValue === "" || performanceValue == null) {
    return "none";
  }
  if (performanceValue <= 24.99) {
    return "var(--UI-red-500, #FF3864)";
  } else if (performanceValue >= 25 && performanceValue <= 49.99) {
    return "var(--Brand-orange-500, #FF7800)";
  } else if (performanceValue >= 50 && performanceValue <= 74.99) {
    return "var(--UI-yellow-500, #F2E94E)";
  } else if (performanceValue >= 75 && performanceValue <= 87.99) {
    return "#C9F0B6";
  } else if (performanceValue >= 88 && performanceValue <= 98.99) {
    return "var(--Brand-green-2-500, #4AF075)";
  } else if (performanceValue >= 99) {
    return "#00D1A8";
  } else if (performanceValue === 0) {
    return "#DADADA";
  } else {
    return "red";
  }
};

export const getBorderColor = (performanceValue: number | "") => {
  if (performanceValue === "" || performanceValue == null) {
    return "none";
  }
  if (performanceValue <= 24.99) {
    return "var(--UI-red-500, #ec204dff)";
  } else if (performanceValue >= 25 && performanceValue <= 49.99) {
    return "var(--Brand-orange-500, #e76f05ff)";
  } else if (performanceValue >= 50 && performanceValue <= 74.99) {
    return "var(--UI-yellow-500, #DDD447)";
  } else if (performanceValue >= 75 && performanceValue <= 87.99) {
    return "#B7DAA6";
  } else if (performanceValue >= 88 && performanceValue <= 98.99) {
    return "var(--Brand-green-2-500, #43DA6A)";
  } else if (performanceValue >= 99) {
    return "#06a585ff";
  } else if (performanceValue === 0) {
    return "#DADADA";
  } else {
    return "red";
  }
};
